// extracted by mini-css-extract-plugin
export default {"wrapper":"UserDetailsDashboard_wrapper__dLpeV","info":"UserDetailsDashboard_info__mugHX","content":"UserDetailsDashboard_content__UXGJ1"};